import { AppointmentConfigurationCreateOrUpdateCommand } from '@dreryk/egabinet-appointment-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../translations';

import { OverlappingAppointmentsAllowedFormBean } from './OverlappingAppointmentsConfigurationForm.types';

export const useAppointmentConfigurationCreateOrUpdateCommand = (): UseCqrsCommandResult<
   void,
   OverlappingAppointmentsAllowedFormBean
> => {
   return useCqrsCommand<void, OverlappingAppointmentsAllowedFormBean>(
      (parameters) => {
         const command = new AppointmentConfigurationCreateOrUpdateCommand();
         command.overlappingAppointmentsAllowed = parameters.overlappingAppointmentsAllowed;
         return command;
      },
      {
         onSuccess: () =>
            dispatchSnackbarPositiveEvent(generalSettingsTranslationKeys.calendar.overlappingAppointmentsToggle),
      }
   );
};
